function toggleFaq(el) {
  el.classList.toggle('open');
}

/* ---- Sticky add-to-bag (mobile) ---- */
function initStickyATB() {
  var bar = document.getElementById('sticky-atb');
  if (!bar) return;
  if (!document.querySelector('.pcard')) return;
  var nameEl = document.getElementById('sticky-atb-name');
  var priceEl = document.getElementById('sticky-atb-price');

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var card = entry.target;
        var nameDiv = card.querySelector('.pcard-name');
        var priceDiv = card.querySelector('.pcard-price');
        if (nameDiv && nameEl) {
          var n = nameDiv.textContent.trim();
          nameEl.textContent = n.length > 28 ? n.substring(0, 26) + '…' : n;
        }
        if (priceDiv && priceEl) priceEl.textContent = priceDiv.textContent.trim();
      }
    });
  }, {threshold: 0.3});

  document.querySelectorAll('.pcard').forEach(function(card) { observer.observe(card); });

  window.addEventListener('scroll', function() {
    var sy = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
    if (sy > 350) {
      bar.classList.add('show');
    } else {
      bar.classList.remove('show');
    }
  }, {passive: true});
}


/* ---- WC countdown to the Final ---- */
function startWCCountdown() {
  var dEl = document.getElementById('wc-d');
  var hEl = document.getElementById('wc-h');
  var mEl = document.getElementById('wc-m');
  var sEl = document.getElementById('wc-s');
  if (!dEl) return;
  var finalDate = new Date('2026-07-19T19:00:00Z'); // 20:00 BST
  function update() {
    var diff = finalDate - new Date();
    if (diff <= 0) { dEl.textContent = hEl.textContent = mEl.textContent = sEl.textContent = '00'; return; }
    var fmt = function(n) { return String(n).padStart(2, '0'); };
    dEl.textContent = fmt(Math.floor(diff / 86400000));
    hEl.textContent = fmt(Math.floor((diff % 86400000) / 3600000));
    mEl.textContent = fmt(Math.floor((diff % 3600000) / 60000));
    sEl.textContent = fmt(Math.floor((diff % 60000) / 1000));
  }
  update();
  setInterval(update, 1000);
}

/* ---- TikTok scroll reveal ---- */
function initTikTokReveal() {
  var cards = document.querySelectorAll('.tiktok-reveal');
  if (!cards.length) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, {threshold: 0.08});
  cards.forEach(function(card, i) {
    card.style.transitionDelay = (i % 3 * 0.12) + 's';
    observer.observe(card);
  });
}

/* ---- TikTok floating dots ---- */
function initTikTokDots() {
  var container = document.getElementById('tiktok-dots');
  if (!container) return;
  for (var i = 0; i < 14; i++) {
    var dot = document.createElement('div');
    dot.className = 'tiktok-dot';
    dot.style.left = (Math.random() * 100) + '%';
    dot.style.top = (30 + Math.random() * 70) + '%';
    dot.style.animationDuration = (3 + Math.random() * 5) + 's';
    dot.style.animationDelay = (Math.random() * 6) + 's';
    dot.style.width = dot.style.height = (2 + Math.random() * 3) + 'px';
    container.appendChild(dot);
  }
}

function startCountdown() {
  var cdD = document.getElementById('cd-d');
  var cdH = document.getElementById('cd-h');
  var cdM = document.getElementById('cd-m');
  var cdS = document.getElementById('cd-s');
  if (!cdH) return;
  // Summer sale ends August 31 2026 at 23:59 BST (= 22:59 UTC)
  var target = new Date('2026-08-31T22:59:00Z');
  function update() {
    var diff = target - new Date();
    var fmt = function(n) { return String(Math.max(0, n)).padStart(2, '0'); };
    if (diff <= 0) {
      if (cdD) cdD.textContent = '00';
      cdH.textContent = cdM.textContent = cdS.textContent = '00';
      var bs = document.getElementById('bs-timer');
      if (bs) bs.textContent = '00:00:00';
      return;
    }
    var totalSecs = Math.floor(diff / 1000);
    var d = Math.floor(totalSecs / 86400);
    var h = Math.floor((totalSecs % 86400) / 3600);
    var m = Math.floor((totalSecs % 3600) / 60);
    var s = totalSecs % 60;
    if (cdD) cdD.textContent = fmt(d);
    cdH.textContent = fmt(h);
    cdM.textContent = fmt(m);
    cdS.textContent = fmt(s);
    var bs = document.getElementById('bs-timer');
    if (bs) bs.textContent = fmt(h) + ':' + fmt(m) + ':' + fmt(s);
  }
  update();
  setInterval(update, 1000);
}


function toggleMenu() {
  var nav = document.getElementById('mobile-nav');
  var overlay = document.getElementById('mobile-overlay');
  if (!nav) return;
  var isOpen = nav.classList.toggle('open');
  if (overlay) overlay.classList.toggle('open');
  document.body.style.overflow = isOpen ? 'hidden' : '';
  nav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  if (isOpen) { nav.removeAttribute('inert'); } else { nav.setAttribute('inert', ''); }
}

function addToBag(btn) {
  var variantId = parseInt(btn.getAttribute('data-variant-id') || '0', 10);
  var productName = btn.getAttribute('data-product-name') || '';
  var original = btn.textContent;
  btn.textContent = 'Adding…';
  btn.disabled = true;
  btn.style.opacity = '0.7';
  btn.classList.add('btn-working');
  if (variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({id: variantId, quantity: 1})
    })
    .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function(data) {
      btn.classList.remove('btn-working');
      btn.textContent = 'Added ✓';
      btn.style.opacity = '1';
      btn.style.background = '#1D9E75';
      btn.style.borderColor = '#1D9E75';
      showCartToast(data.title || productName || original);
      return fetch('/cart.js');
    })
    .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function(cart) {
      if (cart) renderMiniCart(cart);
      setTimeout(function() {
        btn.textContent = original;
        btn.style.background = '';
        btn.style.borderColor = '';
        btn.disabled = false;
      }, 1800);
    })
    .catch(function() {
      btn.classList.remove('btn-working');
      btn.textContent = original;
      btn.style.background = '';
      btn.style.opacity = '1';
      btn.disabled = false;
    });
    return;
  }
  // Visual-only fallback (no real product linked yet)
  setTimeout(function() {
    btn.classList.remove('btn-working');
    btn.textContent = 'Added ✓';
    btn.style.opacity = '1';
    btn.style.background = '#1D9E75';
    btn.style.borderColor = '#1D9E75';
    setTimeout(function() {
      btn.textContent = original;
      btn.style.background = '';
      btn.style.borderColor = '';
      btn.disabled = false;
    }, 1800);
  }, 600);
}

/* ---- Mini cart ---- */
function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2);
}

function renderMiniCart(cart) {
  var countEl = document.getElementById('minicart-count');
  var subtotalEl = document.getElementById('minicart-subtotal');
  var itemsEl = document.getElementById('minicart-items');
  if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  document.querySelectorAll('.cart-badge').forEach(function(el) {
    if (el.textContent !== String(cart.item_count)) el.textContent = cart.item_count;
  });
  var cartLink = document.querySelector('.cart-icon-link');
  if (cartLink) cartLink.setAttribute('aria-label', 'Cart, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
  if (!itemsEl) return;
  if (!cart.items || cart.items.length === 0) {
    itemsEl.innerHTML = '<div class="minicart-empty">🛒 Your bag is empty</div>';
    return;
  }
  itemsEl.innerHTML = cart.items.map(function(item) {
    var imgHtml = item.featured_image && item.featured_image.url
      ? '<img src="' + esc(item.featured_image.url) + '" alt="' + esc(item.product_title) + '">'
      : '<span>🛍️</span>';
    var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="minicart-item-variant">' + esc(item.variant_title) + '</div>' : '';
    return '<div class="minicart-item">' +
      '<div class="minicart-item-img">' + imgHtml + '</div>' +
      '<div class="minicart-item-info">' +
        '<a href="' + esc(item.url) + '" class="minicart-item-title">' + esc(item.product_title) + '</a>' +
        variantHtml +
        '<div class="minicart-item-price">' + formatMoney(item.final_price) + '</div>' +
      '</div>' +
      '<div class="minicart-item-qty">' +
        '<button class="minicart-qty-btn" onclick="updateMiniCartQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>' +
        '<span class="minicart-qty-num">' + item.quantity + '</span>' +
        '<button class="minicart-qty-btn" onclick="updateMiniCartQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
      '</div>' +
      '<button class="minicart-remove" onclick="updateMiniCartQty(\'' + item.key + '\',0)" aria-label="Remove">✕</button>' +
    '</div>';
  }).join('');
}

function updateMiniCartQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: key, quantity: qty})
  })
  .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
  .then(renderMiniCart)
  .catch(function(e) { console.error('Cart update error:', e); });
}

function fetchAndRenderMiniCart() {
  fetch('/cart.js')
    .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(renderMiniCart)
    .catch(function(e) { console.error('Mini cart fetch error:', e); });
}

function showCartToast(productName) {
  var toast = document.getElementById('cart-toast');
  var nameEl = document.getElementById('cart-toast-product');
  if (!toast) return;
  if (nameEl) nameEl.textContent = productName || '';
  toast.classList.add('show');
  clearTimeout(window._toastTimer);
  window._toastTimer = setTimeout(function() { toast.classList.remove('show'); }, 3500);
}

function initMiniCart() {
  var cartWrap = document.getElementById('cart-wrap');
  var minicart = document.getElementById('minicart');
  if (!cartWrap || !minicart) return;
  var timer = null;
  var loaded = false;
  function open() {
    if (timer) { clearTimeout(timer); timer = null; }
    minicart.classList.add('open');
    if (!loaded) { loaded = true; fetchAndRenderMiniCart(); }
  }
  function close() {
    timer = setTimeout(function() { minicart.classList.remove('open'); }, 300);
  }
  cartWrap.addEventListener('mouseenter', open);
  cartWrap.addEventListener('mouseleave', close);
  minicart.addEventListener('mouseenter', function() { if (timer) { clearTimeout(timer); timer = null; } });
  minicart.addEventListener('mouseleave', close);
}

/* ---- Header search overlay ----
   Triggers are any .js-search-open (desktop icon button + mobile nav link).
   The mobile trigger is a real <a href="/search"> so it still works with JS
   off/broken — we only preventDefault once the overlay is actually available.
   aria-hidden + inert are toggled together (same pattern as the mobile nav)
   so the form can't be focused while the overlay is closed. */
function initSearchOverlay() {
  var overlay = document.getElementById('search-overlay');
  var input = document.getElementById('search-overlay-input');
  if (!overlay || !input) return;
  var lastTrigger = null;

  function open(trigger) {
    lastTrigger = trigger || null;
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { input.focus(); }, 60);
  }
  function close() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('inert', '');
    document.body.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  document.addEventListener('click', function(e) {
    var opener = e.target.closest ? e.target.closest('.js-search-open') : null;
    if (opener) { e.preventDefault(); open(opener); return; }
    if (e.target.closest && e.target.closest('.js-search-close')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('open')) close();
  });

  // Don't submit an empty query (Shopify would render a bare results page)
  var form = overlay.querySelector('.search-overlay-form');
  if (form) form.addEventListener('submit', function(e) {
    if (!input.value.trim()) { e.preventDefault(); input.focus(); }
  });
}

/* ---- Nav dropdown with hover grace period ---- */
function initNavDropdown() {
  document.querySelectorAll('.nav-dropdown-wrap').forEach(function(wrap) {
    var dropdown = wrap.querySelector('.nav-dropdown');
    if (!dropdown) return;
    var timer = null;
    function show() {
      if (timer) { clearTimeout(timer); timer = null; }
      dropdown.style.display = 'flex';
      wrap.classList.add('dd-open');
    }
    function hide() {
      timer = setTimeout(function() {
        dropdown.style.display = 'none';
        wrap.classList.remove('dd-open');
      }, 320);
    }
    wrap.addEventListener('mouseenter', show);
    wrap.addEventListener('mouseleave', hide);
    dropdown.addEventListener('mouseenter', show);
    dropdown.addEventListener('mouseleave', hide);
  });
}

/* ---- AJAX add-to-cart (product page — no redirect) ---- */
function initProductATCForm() {
  var form = document.getElementById('product-atc-form');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var variantId = parseInt(document.getElementById('product-variant-id').value, 10);
    var qty = parseInt(document.getElementById('product-qty-display').value, 10) || 1;
    var btn = document.getElementById('product-atc-btn');
    var origText = btn ? btn.textContent : 'Add to bag';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; btn.style.opacity = '0.7'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({id: variantId, quantity: qty})
    })
    .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function(data) {
      var productName = data.title || data.product_title || origText;
      if (btn) {
        btn.textContent = 'Added ✓';
        btn.style.background = '#1D9E75';
        btn.style.opacity = '1';
        btn.disabled = false;
        setTimeout(function() {
          btn.textContent = origText;
          btn.style.background = '';
        }, 2000);
      }
      showCartToast(productName);
      return fetch('/cart.js');
    })
    .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function(cart) {
      if (!cart) return;
      renderMiniCart(cart);
      // Reset minicart loaded flag so it re-fetches on next open
      var minicart = document.getElementById('minicart');
      if (minicart) minicart.classList.remove('open');
    })
    .catch(function(err) {
      console.error('Cart error:', err);
      if (btn) { btn.textContent = origText; btn.disabled = false; btn.style.opacity = '1'; }
    });
  });
}

/* ---- Summer page sort ---- */
function initSummerSort() {
  var grid = document.getElementById('summer-products-grid');
  var btns = document.querySelectorAll('.sort-btn');
  if (!grid || !btns.length) return;
  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      btns.forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      sortSummerGrid(grid, this.getAttribute('data-sort'));
    });
  });
}

function sortSummerGrid(grid, mode) {
  var cards = Array.from(grid.querySelectorAll('.summer-prod-card'));
  cards.sort(function(a, b) {
    if (mode === 'price-asc') return parseFloat((a.getAttribute('data-price') || '0').replace(/[^0-9.]/g, '')) - parseFloat((b.getAttribute('data-price') || '0').replace(/[^0-9.]/g, ''));
    if (mode === 'price-desc') return parseFloat((b.getAttribute('data-price') || '0').replace(/[^0-9.]/g, '')) - parseFloat((a.getAttribute('data-price') || '0').replace(/[^0-9.]/g, ''));
    if (mode === 'az') return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || '');
    if (mode === 'za') return (b.getAttribute('data-name') || '').localeCompare(a.getAttribute('data-name') || '');
    return 0;
  });
  cards.forEach(function(card) { grid.appendChild(card); });
}

/* ---- Summer floating particles ---- */
function initSummerParticles() {
  var container = document.querySelector('.summer-particles');
  if (!container) return;
  for (var i = 0; i < 12; i++) {
    var p = document.createElement('div');
    p.className = 'summer-particle';
    p.style.left = (Math.random() * 100) + '%';
    p.style.top = (20 + Math.random() * 80) + '%';
    p.style.width = p.style.height = (2 + Math.random() * 4) + 'px';
    p.style.animationDuration = (4 + Math.random() * 6) + 's';
    p.style.animationDelay = (Math.random() * 8) + 's';
    container.appendChild(p);
  }
}

/* ---- Product page ---- */
function initProductPage() {
  // Accordion
  document.querySelectorAll('.product-acc-header').forEach(function(header) {
    header.addEventListener('click', function() {
      var item = this.closest('.product-acc-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.product-acc-item').forEach(function(i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });

  // Gallery thumbnails
  var mainImgEl = document.getElementById('product-main-img');
  document.querySelectorAll('.product-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      if (window._thumbCycleTimer) { clearInterval(window._thumbCycleTimer); window._thumbCycleTimer = null; }
      document.querySelectorAll('.product-thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
      if (mainImgEl) {
        var newSrc = this.getAttribute('data-full');
        var newEmoji = this.getAttribute('data-emoji');
        var newVideo = this.getAttribute('data-video');
        if (newVideo) {
          var hasSound = this.getAttribute('data-has-sound');
          var vid = document.createElement('video');
          // Play once (no loop — a talking clip looping mid-sentence feels cheap);
          // a Replay button appears when it ends.
          vid.autoplay = true; vid.muted = true; vid.loop = false;
          vid.controls = true;
          vid.setAttribute('playsinline', '');
          // Remove download, fullscreen, playback-rate + PiP from the controls.
          // (The file is still technically reachable like any web video, but not one-click.)
          vid.setAttribute('controlsList', 'nodownload nofullscreen noplaybackrate');
          vid.disablePictureInPicture = true;
          vid.oncontextmenu = function() { return false; };
          var poster = this.getAttribute('data-poster');
          if (poster) vid.setAttribute('poster', poster);
          var srcEl = document.createElement('source');
          srcEl.src = newVideo; srcEl.type = 'video/mp4';
          vid.appendChild(srcEl);
          mainImgEl.innerHTML = '';
          mainImgEl.classList.add('has-video');
          mainImgEl.appendChild(vid);

          var replayBtn = null;
          function clearReplay() { if (replayBtn && replayBtn.parentNode) replayBtn.parentNode.removeChild(replayBtn); replayBtn = null; }

          // "Tap for sound" — only on clips that actually carry an audio track.
          // Autoplay must stay muted (browsers block unmuted autoplay); this lets
          // the visitor opt in with a clear cue so a silent talking clip never
          // looks broken.
          if (hasSound) {
            var unmute = document.createElement('button');
            unmute.type = 'button';
            unmute.className = 'product-video-unmute';
            unmute.innerHTML = '🔊 Tap for sound';
            unmute.setAttribute('aria-label', 'Play video with sound');
            unmute.addEventListener('click', function() {
              vid.muted = false;
              vid.currentTime = 0;
              var pp = vid.play();
              if (pp && pp.catch) { pp.catch(function() {}); }
              if (unmute.parentNode) unmute.parentNode.removeChild(unmute);
              clearReplay();
            });
            mainImgEl.appendChild(unmute);
          }

          // Replay button when the clip finishes
          vid.addEventListener('ended', function() {
            if (replayBtn) return;
            replayBtn = document.createElement('button');
            replayBtn.type = 'button';
            replayBtn.className = 'product-video-replay';
            replayBtn.innerHTML = '↻ Replay';
            replayBtn.setAttribute('aria-label', 'Replay video');
            replayBtn.addEventListener('click', function() {
              clearReplay();
              vid.currentTime = 0;
              var pp = vid.play();
              if (pp && pp.catch) { pp.catch(function() {}); }
            });
            mainImgEl.appendChild(replayBtn);
          });
        } else if (newSrc) {
          var newImg = document.createElement('img');
          newImg.src = newSrc;
          newImg.alt = '';
          mainImgEl.innerHTML = '';
          mainImgEl.classList.remove('has-video');
          mainImgEl.appendChild(newImg);
        } else if (newEmoji) {
          var emojiSpan = document.createElement('span');
          emojiSpan.style.fontSize = '120px';
          emojiSpan.textContent = newEmoji;
          mainImgEl.innerHTML = '';
          mainImgEl.classList.remove('has-video');
          mainImgEl.appendChild(emojiSpan);
        }
      }
    });
  });

  // Qty buttons — update visible display (AJAX form reads from display)
  var qtyDisplay = document.getElementById('product-qty-display');
  var qtyInput = document.getElementById('product-qty-input');
  if (qtyDisplay) {
    var qtyMinus = document.getElementById('qty-minus');
    var qtyPlus = document.getElementById('qty-plus');
    if (qtyMinus) qtyMinus.addEventListener('click', function() {
      var v = parseInt(qtyDisplay.value, 10) || 1;
      if (v > 1) { qtyDisplay.value = v - 1; if (qtyInput) qtyInput.value = v - 1; }
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function() {
      var v = parseInt(qtyDisplay.value, 10) || 1;
      if (v < 99) { qtyDisplay.value = v + 1; if (qtyInput) qtyInput.value = v + 1; }
    });
  }

  // Text option buttons
  document.querySelectorAll('.product-opt-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('unavailable')) return;
      var group = this.getAttribute('data-option');
      var idx = this.getAttribute('data-opt-index');
      document.querySelectorAll('.product-opt-btn[data-option="' + group + '"]').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      var valEl = document.getElementById('opt-val-' + idx);
      if (valEl) valEl.textContent = this.getAttribute('data-value');
      updateProductVariant();
    });
  });

  // Color swatch buttons
  document.querySelectorAll('.product-opt-swatch').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('unavailable')) return;
      var group = this.getAttribute('data-option');
      var idx = this.getAttribute('data-opt-index');
      document.querySelectorAll('.product-opt-swatch[data-option="' + group + '"]').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      var valEl = document.getElementById('opt-val-' + idx);
      if (valEl) valEl.textContent = this.getAttribute('data-value');
      updateProductVariant();
    });
  });

  // Open first accordion item by default
  var firstAcc = document.querySelector('.product-acc-item');
  if (firstAcc) firstAcc.classList.add('open');
}

function updateProductVariant() {
  var variantsEl = document.getElementById('product-variants-json');
  if (!variantsEl) return;
  var variants;
  try { variants = JSON.parse(variantsEl.textContent); } catch(e) { return; }
  var selected = {};
  document.querySelectorAll('.product-opt-btn.selected, .product-opt-swatch.selected').forEach(function(btn) {
    selected[btn.getAttribute('data-option')] = btn.getAttribute('data-value');
  });
  var optionNames = Object.keys(selected);
  var match = variants.find(function(v) {
    return optionNames.every(function(k, i) { return v.options[i] === selected[k]; });
  });
  if (!match) return;
  var idInput = document.getElementById('product-variant-id');
  if (idInput) idInput.value = match.id;
  var priceEl = document.getElementById('product-price-display');
  if (priceEl && match.price) {
    priceEl.textContent = '£' + (match.price / 100).toFixed(2);
  }
  var atcBtn = document.getElementById('product-atc-btn');
  if (atcBtn) {
    atcBtn.disabled = !match.available;
    atcBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
    atcBtn.style.opacity = match.available ? '' : '0.5';
  }
  // Switch gallery image if this variant has its own image
  if (match.featured_image && match.featured_image.src) {
    var src = match.featured_image.src;
    var mainImgEl = document.getElementById('product-main-img');
    if (mainImgEl) {
      mainImgEl.classList.remove('has-video');
      mainImgEl.innerHTML = '<img src="' + src + '" alt="" style="width:100%;height:100%;object-fit:contain;">';
    }
    document.querySelectorAll('.product-thumb').forEach(function(t) {
      t.classList.remove('active');
      if (t.getAttribute('data-full') === src) t.classList.add('active');
    });
  }
  // Refresh the Save-for-later heart to reflect the newly-selected variant
  if (window.MomentaSaved) MomentaSaved.sync();
}

function initBackToTop() {
  var btn = document.getElementById('back-to-top');
  if (!btn) return;
  window.addEventListener('scroll', function() {
    var sy = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
    btn.classList.toggle('show', sy > 600);
  }, {passive: true});
  btn.addEventListener('click', function() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  });
}

/* 3D tilt on product cards — pointer-tracked, transform-only, rAF-throttled.
   Delegated on document so cards added later (Load More, filters) work too. */
var _tiltCard = null, _tiltRaf = null;
function initCardTilt() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;
  function resetTilt() {
    if (_tiltCard) {
      _tiltCard.style.transform = '';
      _tiltCard.style.transition = '';
      _tiltCard = null;
    }
  }
  document.addEventListener('mousemove', function(e) {
    var card = e.target && e.target.closest ? e.target.closest('.pcard') : null;
    if (!card && !_tiltCard) return;
    if (_tiltRaf) return;
    _tiltRaf = requestAnimationFrame(function() {
      _tiltRaf = null;
      if (_tiltCard && _tiltCard !== card) resetTilt();
      if (card) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transition = 'transform 0.12s ease-out';
        card.style.transform = 'perspective(900px) rotateX(' + (-py * 4).toFixed(2) + 'deg) rotateY(' + (px * 5).toFixed(2) + 'deg) translateY(-4px)';
        _tiltCard = card;
      }
    });
  }, { passive: true });
  /* Reset when the pointer leaves the window entirely */
  document.addEventListener('mouseout', function(e) {
    if (!e.relatedTarget) resetTilt();
  });
}

/* Card → product-page image morph. The clicked card's image gets a
   view-transition-name at click time (so only ONE element ever carries it,
   even when a product appears in multiple grids on the same page); the PDP
   claims the same name via an inline script if the handles match. Harmless
   no-op on browsers without cross-document view transitions. */
function initCardMorph() {
  document.addEventListener('click', function(e) {
    var link = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!link) return;
    var img = link.querySelector('.pcard-img img');
    if (!img) return;
    var m = link.getAttribute('href').match(/\/products\/([a-z0-9-]+)/);
    if (!m) return;
    try { sessionStorage.setItem('vt-product', m[1]); } catch (err) {}
    var prev = document.querySelector('.pcard-img img[style*="momenta-pdp-image"], #product-main-img img[style*="momenta-pdp-image"]');
    if (prev && prev !== img) prev.style.viewTransitionName = '';
    img.style.viewTransitionName = 'momenta-pdp-image';
  });
}

/* Image-load fade — card images fade in over a shimmer placeholder instead
   of popping in raw. Armed-by-JS (containers are only marked .img-fade once
   we know the image is still loading), so no-JS / cached / reduced-motion
   paths always show images instantly. */
function initImageLoadFade() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var boxes = document.querySelectorAll('.pcard-img, .coll-spot-media');
  boxes.forEach(function(box) {
    var img = box.querySelector('img');
    if (!img || img.complete) return;
    box.classList.add('img-fade');
    var reveal = function() { box.classList.add('img-in'); };
    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', reveal, { once: true });
    setTimeout(reveal, 4000); /* safety: never stay hidden */
  });
}

/* Hover-video preview — cards whose product has branded b-roll/UGC footage
   (data-hover-video on .pcard-img) crossfade into the muted looping clip on
   hover. Desktop fine-pointer only; reduced-motion users never see it. */
var _hvActive = null;
function removeHoverVideo() {
  if (!_hvActive) return;
  var v = _hvActive.querySelector('.pcard-hover-video');
  if (v) {
    try { v.pause(); } catch (e) {}
    /* Abort the media download — pause()+remove() alone keeps fetching */
    while (v.firstChild) v.removeChild(v.firstChild);
    v.removeAttribute('src');
    try { v.load(); } catch (e) {}
    v.remove();
  }
  _hvActive = null;
}
function initCardVideoHover() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;
  document.addEventListener('mouseover', function(e) {
    var box = e.target && e.target.closest ? e.target.closest('.pcard-img[data-hover-video]') : null;
    if (!box || box === _hvActive) return;
    var card = box.closest('.pcard');
    if (card && card.classList.contains('pcard-soldout')) return;
    removeHoverVideo();
    var vid = document.createElement('video');
    vid.className = 'pcard-hover-video';
    vid.autoplay = true; vid.muted = true; vid.loop = true;
    vid.setAttribute('playsinline', '');
    var src = document.createElement('source');
    src.src = box.getAttribute('data-hover-video');
    src.type = 'video/mp4';
    vid.appendChild(src);
    box.appendChild(vid);
    /* Double-rAF so the browser paints opacity:0 first — a single rAF runs
       before style recalc and the 0.35s crossfade never fires */
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { vid.classList.add('on'); });
    });
    _hvActive = box;
  });
  document.addEventListener('mouseout', function(e) {
    if (!_hvActive) return;
    var to = e.relatedTarget;
    if (to && _hvActive.contains(to)) return;
    if (e.target && _hvActive.contains(e.target)) removeHoverVideo();
  });
}

var _revealObserver = null;
function initRevealAnimations() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  _revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        _revealObserver.unobserve(entry.target);
      }
    });
  }, {threshold: 0.08, rootMargin: '0px 0px -40px 0px'});
  document.querySelectorAll('.pcard, .bundle-card, .bestseller-inner, .sec-head, .sec-head-white, .cmp-header, .hiw-header, .lsb-copy').forEach(function(el) {
    el.classList.add('reveal');
    _revealObserver.observe(el);
  });
}

/* ========== Save for later (localStorage wishlist) ========== */
var MomentaSaved = (function () {
  var KEY = 'momenta_saved_v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function has(id) { return read().some(function (i) { return String(i.id) === String(id); }); }
  function count() { return read().length; }
  function toggle(item) {
    if (!item.id) return false;
    var a = read(), idx = -1;
    for (var i = 0; i < a.length; i++) { if (String(a[i].id) === String(item.id)) { idx = i; break; } }
    var added;
    if (idx > -1) { a.splice(idx, 1); added = false; } else { a.unshift(item); added = true; }
    write(a); sync(); return added;
  }
  function remove(id) { write(read().filter(function (i) { return String(i.id) !== String(id); })); sync(); }
  /* Which variant id a button currently represents — live selection on a PDP,
     else its static data-save-id (gift cards, grid cards) */
  function btnCurrentId(btn) {
    if (btn.getAttribute('data-save-live') === 'product') {
      var el = document.getElementById('product-variant-id');
      if (el && el.value) return el.value;
    }
    return btn.getAttribute('data-save-id') || '';
  }
  function setBtn(btn, saved) {
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var heart = btn.querySelector('.js-save-heart'); if (heart) heart.textContent = saved ? '♥' : '♡';
    var label = btn.querySelector('.js-save-label');
    if (label) label.textContent = saved ? (btn.getAttribute('data-saved-label') || 'Saved') : (btn.getAttribute('data-save-label') || 'Save for later');
  }
  function sync() {
    var c = count();
    document.querySelectorAll('.js-saved-count').forEach(function (el) { el.textContent = c; el.classList.toggle('has-items', c > 0); });
    document.querySelectorAll('.js-save-btn').forEach(function (b) { setBtn(b, has(btnCurrentId(b))); });
    renderPage();
  }
  function renderPage() {
    var grid = document.getElementById('saved-grid');
    if (!grid) return;
    var items = read(), empty = document.getElementById('saved-empty');
    if (!items.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    grid.innerHTML = items.map(function (p) {
      return '<div class="saved-card" data-handle="' + esc(p.handle) + '">' +
        '<a class="saved-card-img" href="' + esc(p.url) + '"><img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="300" height="300"></a>' +
        '<div class="saved-card-body">' +
          '<a class="saved-card-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          (p.variant ? '<div class="saved-card-variant">' + esc(p.variant) + '</div>' : '') +
          '<div class="saved-card-price">' + (p.price ? '£' + (p.price / 100).toFixed(2) : '') + '</div>' +
          '<div class="saved-card-actions">' +
            (p.id ? '<button type="button" class="btn-bag" data-variant-id="' + esc(p.id) + '" data-product-name="' + esc(p.title) + '" onclick="addToBag(this)">Add to bag</button>' : '') +
            '<button type="button" class="saved-remove js-saved-remove" data-id="' + esc(p.id) + '" aria-label="Remove ' + esc(p.title) + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }
  return { read: read, has: has, count: count, toggle: toggle, remove: remove, sync: sync };
})();

/* On a PDP, find the currently-selected variant object from the variants JSON so
   the saved card can show its exact name + price (not just the default). */
function savedLiveVariant(save, liveEl) {
  if (!save || save.getAttribute('data-save-live') !== 'product') return null;
  var el = document.getElementById('product-variants-json');
  var id = liveEl && liveEl.value;
  if (!el || !id) return null;
  try {
    var vars = JSON.parse(el.textContent);
    for (var i = 0; i < vars.length; i++) { if (String(vars[i].id) === String(id)) return vars[i]; }
  } catch (e) {}
  return null;
}

function initSaved() {
  MomentaSaved.sync();
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var save = e.target.closest('.js-save-btn');
    if (save) {
      e.preventDefault();
      var liveEl = (save.getAttribute('data-save-live') === 'product') ? document.getElementById('product-variant-id') : null;
      var v = savedLiveVariant(save, liveEl);
      var vLabel = (v && v.title && v.title !== 'Default Title') ? v.title : (save.getAttribute('data-save-variant') || '');
      var vPrice = (v && typeof v.price === 'number') ? v.price : parseInt(save.getAttribute('data-save-price') || '0', 10);
      MomentaSaved.toggle({
        handle: save.getAttribute('data-save-handle'),
        id: (liveEl && liveEl.value) || save.getAttribute('data-save-id') || '',
        title: save.getAttribute('data-save-title') || '',
        url: save.getAttribute('data-save-url') || '',
        img: save.getAttribute('data-save-img') || '',
        price: vPrice,
        variant: vLabel
      });
      return;
    }
    var rm = e.target.closest('.js-saved-remove');
    if (rm) MomentaSaved.remove(rm.getAttribute('data-id'));
  });
}

document.addEventListener('DOMContentLoaded', function() {
  startCountdown();
  startWCCountdown();
  initStickyATB();
  initTikTokReveal();
  initTikTokDots();
  initMiniCart();
  initSearchOverlay();
  initSaved();
  initNavDropdown();
  initProductATCForm();
  initSummerSort();
  initSummerParticles();
  initProductPage();
  initBackToTop();
  initRevealAnimations();
  initCardTilt();
  initCardVideoHover();
  initImageLoadFade();
  initCardMorph();
});
